import moment from 'moment';
import { Common, ApiBind } from './common.model';
import { Carrier } from '../constants';

export class DeviceModel extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'sell_date', model: (value) => moment(value).toDate() })
  sellDate: Date;

  @ApiBind({ column: 'value' })
  value: string;

  @ApiBind({ column: 'carrier' })
  carrier: Carrier;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;

  public toDeleteItemJSON() {
    return { id: this.convertJSONObject(this.id), updated_at: this.convertJSONObject(this.updatedAt) };
  }
}
